var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selectedRowCount)?_c('div',{staticClass:"pendo-table__bulk-actions-header"},[_c('span',[_c('pendo-divider',{attrs:{"direction":"vertical","stroke":"#DADCE5","height":"23px","width":"26px"}})],1),_c('div',[_vm._t("actions")],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }